export const IN_APP_NOTIFICATION = 1;
export const BILLING_OVERVIEW = 3;
export const RATE_OVERRIDE_EXPERIMENT = 5;
export const IN_APP_CANCELLATION = 7;
export const PROVIDER_RATING = 8;
export const IN_APP_CANCELLATION_EA_SAMI = 9;
export const INSTANT_ASSIGN_IN_REQUEST = 11;
export const IN_ADVANCE_PAYOUTS = 12;
export const CUSTOM_EASY_ASSIGN = 13;
export const SHIFT_DISPATCH = 14;

export const flags = [
  {
    id: IN_APP_NOTIFICATION,
    name: 'In-App Notification',
  },
  {
    id: BILLING_OVERVIEW,
    name: 'Billing Overview',
  },
  {
    id: RATE_OVERRIDE_EXPERIMENT,
    name: 'Rate Override Experiment',
  },
  {
    id: IN_APP_CANCELLATION,
    name: 'In-App Cancellation',
  },
  {
    id: PROVIDER_RATING,
    name: 'Provider Rating',
  },
  {
    id: IN_APP_CANCELLATION_EA_SAMI,
    name: 'In-App Cancellation With EA and SAMI',
  },
  {
    id: INSTANT_ASSIGN_IN_REQUEST,
    name: 'Instant Assign In Request (Sync)',
  },
  {
    id: IN_ADVANCE_PAYOUTS,
    name: 'Provider In Advance Payments',
  },
  {
    id: CUSTOM_EASY_ASSIGN,
    name: 'Custom Easy Assign',
  },
  {
    id: SHIFT_DISPATCH,
    name: 'Shift Dispatch',
  },
];
